export default "__VITE_ASSET__bbc19c78__"